import { render, staticRenderFns } from "./WebsiteToolsPercentage.vue?vue&type=template&id=edc2ce1e&scoped=true&"
import script from "./WebsiteToolsPercentage.vue?vue&type=script&lang=js&"
export * from "./WebsiteToolsPercentage.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteToolsPercentage.vue?vue&type=style&index=0&id=edc2ce1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc2ce1e",
  null
  
)

export default component.exports